module.exports = __webpack_public_path__ + "fonts/Rubik-300-arabic7.d2ec738.woff2";